
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/extras",
      function () {
        return require("private-next-pages/extras.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/extras"])
      });
    }
  